/*
 * @Author: hujingyang
 * @Description: 营销 页面框架
 * @LastEditors: yang chenglin
 */
import * as React from 'react';

import Menu from './components/PageNav';
import Index from './components/Header';
import style from './index.module.scss';

const { useEffect } = React;

export default function CjyxLayout(props: {
  children: React.ReactNode;
  pathname: string;
  appLeave: { path: string };
  appEnter: { path: string };
}) {
  const { children, appLeave } = props;

  useEffect(() => {
    // @ts-ignore
    delete window.webpackJsonp;
  }, [appLeave]);

  return (
    <div className={style.cjyx}>
      <div className={style.sider}>
        <Menu />
      </div>
      <div className={style.wrapper}>
        <Index />
        <div className={style.main}>
          {children}
        </div>
      </div>
    </div>
  );
}
